module.exports = __webpack_public_path__ + "img/logo-app-white.3af26687.svg";